import styles from "../../ModalCriarRota/ModalCriarRota.module.css";
import { Field, Form, Formik } from "formik";
import Button from "../../../../../components/components-ui/Button/Button";
import { Col, Grid } from "../../../../../components/Grid";
import {
  customStyles,
  SelectSearch,
} from "../../../../../components/components-ui/SelectSearch/SelectSearch";
import Select from "react-select";
import api from "../../../../../services/Api";
import { useEffect, useState } from "react";
import * as Yup from "yup";
import { toast } from "react-toastify";
import Loading from "../../../../../components/components-ui/Loading/Loading";
import Api from "../../../../../services/Api";

const API_MARCA = "/freguesia/listalocalfreguesia?nome_local=";
const API_ADICIONAR_FORNECEDOR = "/freguesia/adicionarfornecedorfreguesia";

function AdicionarFornecedor({
  closeModal,
  freguesia,
  IdColetasOC,
  setLocaisDaRota,
  setDataLocaisFiltrados,
}) {
  const [marca, setMarca] = useState([]);
  const [inputMarca, setInputMarca] = useState("aa");
  const [loadingInput, setLoadingInput] = useState(false);

  const getMarca = async (input) => {
    setLoadingInput(true);
    await api
      .get(API_MARCA + input)
      .then((res) => {
        setMarca(res.data.data);
        setLoadingInput(false);
      })
      .catch((error) => {
        setLoadingInput(false);
        console.log(error);
      });
  };

  //Buscar locais ao digitar
  useEffect(() => {
    const timer = setTimeout(() => {
      if (inputMarca.length) {
        getMarca(inputMarca);
      } else {
        setMarca([]);
      }
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, [inputMarca]);

  const adicionarFornecedor = async (IdLocal, IdColetasOC) => {
    await Api.post(API_ADICIONAR_FORNECEDOR, {
      IdLocal,
      IdColetasOC,
      freguesia,
    })
      .then((res) => {
        if (res.data.error === 0) {
          console.log(res);
          toast.success(res.data.msg);
          setLocaisDaRota(res.data.data);
          setDataLocaisFiltrados(res.data.data);
          closeModal();
          return;
        }
        toast.warn(res.data.msg);
      })
      .catch((error) => {
        console.log(error);
        const mensagem = error?.response?.data?.message || error?.message;
        toast.error("Algo de errado aconteceu: " + mensagem);
      });
  };

  const validationSchema = Yup.object().shape({
    marca: Yup.object()
      .shape({
        label: Yup.string().required(),
        value: Yup.number().required(),
      })
      .nullable()
      .required("Selecione a marca"),
  });

  return (
    <div className={styles.modal_container}>
      <h2 style={{ textAlign: "center" }}>
        Adicionar Fornecedor a Freguesia ({freguesia})
      </h2>
      <Formik
        initialValues={{
          marca: null,
        }}
        validationSchema={validationSchema}
        onSubmit={(values) =>
          adicionarFornecedor(values.marca.value, IdColetasOC)
        }
      >
        {({
          errors,
          touched,
          values,
          isSubmitting,
          isValid,
          setFieldValue,
        }) => (
          <Form>
            <div>
              <Grid>
                <Col size={12}>
                  <label>Marca</label>
                  <Field name="marca">
                    {({ ...field }) => (
                      <Select
                        {...field}
                        value={values.marca}
                        options={marca.map((values) => ({
                          label: values?.NomeLocal,
                          value: values?.IdLocal,
                        }))}
                        styles={customStyles}
                        placeholder="Digite para buscar..."
                        noOptionsMessage={() =>
                          loadingInput
                            ? "Carregando..."
                            : inputMarca.length
                            ? "Nenhuma opção encontrada"
                            : "Digite parte do nome"
                        }
                        onChange={(selectedOption) =>
                          setFieldValue("marca", selectedOption)
                        }
                        onInputChange={(e) => setInputMarca(e)}
                        isClearable
                        menuPortalTarget={document.body}
                      />
                    )}
                  </Field>
                  {errors.marca && touched.marca ? (
                    <span className={styles.alertError}>{errors.marca}</span>
                  ) : null}
                </Col>
              </Grid>
              <div className={styles.buttons_container}>
                <Button
                  title="Salvar"
                  type="submit"
                  disabled={isSubmitting}
                  className={styles.button_sm}
                />
                <Button
                  title="Cancelar"
                  type="button"
                  disabled={isSubmitting}
                  onClick={() => closeModal()}
                  color={"secondary"}
                  className={styles.button_sm}
                />
              </div>
              {isSubmitting && (
                <div className={styles.loading_container}>
                  <Loading display={isSubmitting ? "block" : "none"} />
                </div>
              )}
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default AdicionarFornecedor;
